import { gql } from "@apollo/client";

export const FETCH_PERMISSIONS = gql`
  query FetchPermissions($userId: String!, $orgPath: String!) {
    person(
      where: {
        _or: [
          {
            # non avela admin
            user_id: { _eq: $userId }
            organization: { path: { _eq: $orgPath } }
          }
          {
            # avela admin
            user_id: { _eq: $userId }
            organization_id: { _is_null: true }
            person_type: { _eq: admin }
          }
        ]
      }
    ) {
      user {
        school_users {
          school_access_permission
        }
      }
      user_group {
        name
        user_group_permissions {
          permission
        }
      }
    }
  }
`;

export const FETCH_USER_ATTRIBUTES = gql`
  query FetchUserAttributes($userID: String!) {
    user_by_pk(id: $userID) {
      school_users {
        school_id
        school_access_permission
      }
    }
  }
`;
